<template>
  <main @click="onClick()">
    <div>
      <img v-if="preview" v-bind:src="preview" type="file" />
      <K2Image :src="currentStuImg" v-else-if="currentStuImg" :errorImage="assets.image.boy" />
      <img :src="assets.image.boy" crossorigin v-else />
      <input ref="studentPhotoInput" type="file" accept="image/*" @change="loadPreview" />
      <div class="text-center text-red my-1">Click to upload Child's Photo</div>
    </div>
  </main>
</template>

<script>
import K2Image from '@/uiComponents/k2Image/k2Image'
import assets from '@/assets/assets'
export default {
  components: { K2Image },
  emits: ['change'],
  props: ['group', 'currentStuImg'],
  data() {
    return {
      preview: '',
      assets: assets,
    }
  },
  methods: {
    loadPreview: function (e) {
      const files = e.target?.files || e.dataTransfer.files
      files[0].uploadType = 'stuIMG'
      this.$emit('change', files)
      if (e.target?.files && e.target?.files[0]) {
        const reader = new FileReader()
        reader.onload = e => (this.preview = e.target.result)
        reader.readAsDataURL(e.target?.files[0])
      }
    },

    onClick() {
      this.$refs.studentPhotoInput.click()
    },
  },
}
</script>

<style scoped>
main {
  margin-left: auto;
  width: 180px;
  height: 200px;
  cursor: pointer;
  border-radius: 6px;
}

img {
  height: 100%;
  object-fit: contain;
  background: #eeeeee;
  border-radius: 11px;
}

input {
  display: none;
}
</style>
